import clsx from 'clsx'
import { Moon, Sun } from 'lucide-react'
import { useTheme, type Theme } from '@/store/theme'

const OPTIONS: { value: Theme; label: string; icon: typeof Sun }[] = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
]

/**
 * Appearance switch.
 *
 * <p>Light is the default for everyone; this only records a deliberate change
 * away from it, and that choice is remembered across sessions.
 */
export function ThemeToggle() {
  const theme = useTheme((s) => s.theme)
  const setTheme = useTheme((s) => s.setTheme)

  return (
    <div
      role="radiogroup"
      aria-label="Appearance"
      className="flex items-center gap-0.5 rounded-lg bg-surface-sunken p-0.5"
    >
      {OPTIONS.map((option) => {
        const active = theme === option.value
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={option.label}
            title={option.label}
            onClick={() => setTheme(option.value)}
            className={clsx(
              'flex h-6 w-6 items-center justify-center rounded-md transition',
              active
                ? 'bg-surface text-content shadow-sm'
                : 'text-content-muted hover:text-content',
            )}
          >
            <option.icon size={13} />
          </button>
        )
      })}
    </div>
  )
}
